<template>
    <v-dialog v-model="dialog" max-width="600px" persistent>
        <v-card>
            <v-card-title class="text-h5">
                Atualizar dados
                <v-spacer></v-spacer>
                <v-btn icon @click="closeModal">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="12">
                            <v-text-field v-model="formData.country" label="País de origem" outlined dense hide-details
                                class="mb-3"></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12">
                            <v-text-field v-model="formData.cnpj" label="CNPJ" outlined dense hide-details
                                class="mb-3"></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12">
                            <v-text-field v-model="formData.companyName" label="Razão social" outlined dense
                                hide-details class="mb-3"></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12">
                            <v-text-field v-model="formData.tradeName" label="Nome fantasia" outlined dense hide-details
                                class="mb-3"></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12">
                            <v-text-field v-model="formData.displayName" label="Display name" outlined dense
                                hide-details class="mb-3"></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12">
                            <v-text-field v-model="formData.stateRegistration" label="Inscrição estadual" outlined dense
                                hide-details class="mb-3"></v-text-field>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="closeModal">Cancelar</v-btn>
                <v-btn color="green" dark @click="saveProfile">Salvar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { getAuth } from '@/services/authService'
export default {
    name: 'ProfileEditModal',

    props: {
        value: {
            type: Boolean,
            default: false
        },
        profileId: {
            type: [String, Number],
            required: true
        }
    },

    data() {
        return {
            formData: {
                country: '',
                cnpj: '',
                companyName: '',
                tradeName: '',
                displayName: '',
                stateRegistration: ''
            },
            loading: false
        }
    },

    computed: {
        dialog: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            }
        },

        auth() {
            return getAuth()
        }
    },

    watch: {
        value(newVal) {
            if (newVal && this.profileId) {
                this.fetchProfileData()
            }
        }
    },

    methods: {
        async fetchProfileData() {
            if (!this.profileId) return
            this.loading = true
            try {
                const response = this.$axios.get(`profiles/admin/all?type=2&q=${this.profileId}`)
                console.log('Dados do perfil:', response.data)
            } catch (error) {
                console.error('Erro ao buscar dados do perfil:', error)
            } finally {
                this.loading = false
            }
        },

        closeModal() {
            this.dialog = false
            this.resetForm()
        },

        resetForm() {
            this.formData = {
                country: '',
                cnpj: '',
                companyName: '',
                tradeName: '',
                displayName: '',
                stateRegistration: ''
            }
        },

        saveProfile() {
            console.log('Salvar dados:', this.formData)
            this.closeModal()
        }
    }
}
</script>

<style lang="scss" scoped>
* {
    font-family: 'Roboto', sans-serif !important;
}
</style>